import { render, staticRenderFns } from "./SaasPaymentsWidget.vue?vue&type=template&id=c8e74b24&"
import script from "./SaasPaymentsWidget.vue?vue&type=script&lang=js&"
export * from "./SaasPaymentsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports